const announcementLogRoutes = [
    {
        path: '/announcementManager',
        name: 'announcementManager',
        component: () => import('../../views/announcementLog/AnnouncementManager.vue'),
        meta: { title: 'menu.noticeManage' }
    },
    {
        path: '/operationLog',
        name: 'operationLog',
        component: () => import('../../views/announcementLog/OperationLog.vue'),
        meta: { title: '操作日志' }
    }
]

export default announcementLogRoutes

